import type { Space } from '@cocoonspace/sdk-js/types/space'
import type { BookingRequest } from '@cocoonspace/sdk-js/v2/types/bookingRequest'
import { buttonVariants } from '@cocoonspace/ui/components/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@cocoonspace/ui/components/dialog'
import { Plural, useLingui } from '@lingui/react/macro'
import { LocalizedLink as Link } from '~/components/localized-link'

export const FallbackBookingDialog = ({
	bookingRequest,
	open,
	onOpenChange,
}: {
	bookingRequest: BookingRequest
	open?: boolean
	onOpenChange?: (open: boolean) => void
	requestedSpace: Space
	onBookAlternative: (space: Space) => void
}) => {
	const { t } = useLingui()

	return (
		<Dialog
			open={open}
			onOpenChange={onOpenChange}
		>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>
						<Plural
							value={bookingRequest.location?.space_ids?.length ?? 0}
							one='Espace indisponible'
							other='Espaces indisponibles'
						/>
					</DialogTitle>
				</DialogHeader>

				<p>
					{t`Le Cocoon a été réservé entre temps, aucun Cocoon n'est disponible à cette adresse`}
				</p>

				<Link
					className={buttonVariants({ size: 'sm' })}
					href={{
						pathname: '/paris',
						query: {
							day: bookingRequest.day,
							start: bookingRequest.start,
							end: bookingRequest.end,
						},
					}}
				>
					{t`Réserver à une autre adresse`}
				</Link>
			</DialogContent>
		</Dialog>
	)
}
